'use strict';

bbw.shared.TabsTrait = {

    _initTabs: function() {
        if (angular.isUndefined(this._bbwLocationSvc)) {
            throw new Error('bbw.LocationSvc is not injected');
        }

        var $scope = this.$scope;

        $scope.tabs = {};
        $scope.tabNames = this._getTabNames();

        var tabsLocState = this._bbwLocationSvc.createLocState({
            defaultState: [this._defaultTab],
            states: this._getTabNames(),
            onStateChange: function(state) {
                if ($scope.tabs.$select) {
                    $scope.tabs.$select(state.name);
                } else {
                    $scope.defaultSelectedTab = state.name;
                }
            }
        });

        $scope.onTabSelected = function(name) {
            tabsLocState.setState(name);
        };

        return tabsLocState.run();
    }

};
